import { useMemo } from 'react';
import Button from 'components/Button';
import { useTranslation } from 'services/hooks';
import './style.css';

const AnswerFeedback = ({ feedback, onClick, isFinal = false }) => {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'quiz';

	const textByfeedback = useMemo(() => {
		switch (feedback) {
			case 'correct':
				return getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_answer_feedback_correct_text`);
			case 'incorrect':
				return getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_answer_feedback_incorrect_text`);
			case 'missing':
				return getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_answer_feedback_missing_text`);
			default:
				return '';
		}
	}, [getTranslation]);

	const btnTitle = useMemo(() => {
		if (feedback === 'correct') {
			return isFinal
				? getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_answer_feedback_correct_final_button`)
				: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_answer_feedback_correct_button`);
		}
		return getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_answer_feedback_button`);
	}, [getTranslation]);

	return (
		<div className="AnswerFeedback">
			<div className={`AnswerFeedback__${feedback}`}>{textByfeedback}</div>
			<Button title={btnTitle} endIcon="rightArrow" onClick={() => onClick(feedback)} />
		</div>
	);
};

export default AnswerFeedback;
